var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "更新域名",
        width: "500px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "changeDomain",
        },
        [
          _c("div", { staticClass: "changeDomainTitile" }, [
            _vm._v("重点提示"),
          ]),
          _c("div", { staticClass: "changeDomainTips" }, [
            _c("i", { staticClass: "el-icon-warning-outline fs-16" }),
            _vm._v(" 以下的域名一修改，则所有机构都修改了。请谨慎操作！ "),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "domainUrl", label: "更新邀课主域名：" } },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.form.domainUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "domainUrl", $$v)
                        },
                        expression: "form.domainUrl",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("https://")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          { staticClass: "ss-material-box-bottom" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.sure },
              },
              [_vm._v("保存")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeFn } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }